export const CAR_VALUATION_SEO_PATH = "/used/car-valuation";
